import _ from 'lodash';
import * as actions from '../actions/constants';

const initialState = {
  course: {
    data: null,
    id: null,
    short_id: null,
  },
  loaded: false,
  loading: false,
  error: null,
  activeSubTab: null,
  coursesTabs: null,
};

export function courses(state = initialState, action) {
  const coursesState = _.cloneDeep(state);
  switch (action.type) {
    case actions.GET_COURSE_REQUEST: {
      return {
        ...coursesState,
        loading: true,
        error: null,
      };
    }
    case actions.GET_COURSE_SUCCESS: {
      const courseData = {
        id: action.payload.id,
        data: action.payload.course,
      };

      return {
        ...coursesState,
        course: courseData,
        loaded: true,
        loading: false,
        error: null,
      };
    }
    case actions.GET_COURSE_FAILURE: {
      return {
        ...coursesState,
        loading: false,
        error: action.payload.error,
        loaded: false,
      };
    }
    default:
      return state;
  }
}
